const config = {
  api: {
    baseUrl: `${import.meta.env.VITE_E_PRESCRIBE_API_URL}`,
    websocketBaseUrl: `${import.meta.env.VITE_E_PRESCRIBE_WS_URL}`,
  },
  apiAppendPath: {
    commonAppendPath: `${import.meta.env.VITE_COMMON_APPEND_PATH}`,
    clientAppendPath: `${import.meta.env.VITE_CLIENT_APPEND_PATH}`,
    teleCategoryAppendPath: `${import.meta.env.VITE_TELE_CATEGORY_APPEND_PATH}`,
    stateAppendPath: `${import.meta.env.VITE_STATE_APPEND_PATH}`,
    caseStatusAppendPath: `${import.meta.env.VITE_CASE_STATUS_APPEND_PATH}`,
    physicianAppendPath: `${import.meta.env.VITE_PHYSICIAN_APPEND_PATH}`,
    casesAppendPath: `${import.meta.env.VITE_CASES_APPEND_PATH}`,
    v2CasesAppendPath: `${import.meta.env.VITE_V2_CASES_APPEND_PATH}`,
    questionnaireAppendPath: `${import.meta.env.VITE_QUESTIONNAIRE_APPEND_PATH}`,
    casePhysicianAppendPath: `${import.meta.env.VITE_CASE_PHYSICIAN_APPEND_PATH}`,
    templatesAppendPath: `${import.meta.env.VITE_TEMPLATES_APPEND_PATH}`,
    reportAppendPath: `${import.meta.env.VITE_CASE_REPORT_APPEND_PATH}`,
    v2ReportAppendPath: `${import.meta.env.VITE_V2_REPORT_APPEND_PATH}`,
    physicianApiAppendPath: `${import.meta.env.VITE_PHYSICIAN_API_APPEND_PATH}`,
    userRoleApiAppendPath: `${import.meta.env.VITE_USER_ROLE_APPEND_PATH}`,
    userTypeApiAppendPath: `${import.meta.env.VITE_USER_TYPE_APPEND_PATH}`,
    userApiAppendPath: `${import.meta.env.VITE_USER_APPEND_PATH}`,
    pharmacyAppendPath: `${import.meta.env.VITE_PHARMACY_APPEND_PATH}`,
    reportChartsAppendPath: `${import.meta.env.VITE_REPORT_CHARTS_APPEND_PATH}`,
    medicationsAppendPath: `${import.meta.env.VITE_MEDICATIONS_APPEND_PATH}`,
    chatRoomAppendPath: `${import.meta.env.VITE_CHAT_ROOM_APPEND_PATH}`,
    caseTicketsAppendPath: `${import.meta.env.VITE_CASE_TICKETS_APPEND_PATH}`,
    learningManagementSystemAppendPath: `${import.meta.env.VITE_LEARNING_MANAGEMENT_SYSTEM_APPEND_PATH}`,
    reAssignCaseAppendPath: `${import.meta.env.VITE_REASSIGN_CASE_APPEND_PATH}`,
    patientApiAppendPath: import.meta.env.VITE_PATIENT_APPEND_PATH,
    prescriptionsAppendPath: import.meta.env.VITE_PRESCRIPTIONS_APPEND_PATH,
    labsAppendPath: import.meta.env.VITE_LABS_APPEND_PATH,
    consultationsAppendPath: import.meta.env.VITE_CONSULTATIONS_APPEND_PATH,
    pharmacyNoteConfigsAppendPath: import.meta.env.VITE_PHARMACY_NOTE_CONFIGS_APPEND_PATH,
  },

  completedCaseCheckDeadlineInDays: `${import.meta.env.VITE_COMPLETED_CASE_CHECK_DEADLINE_IN_DAYS}`,

  apiKeys: {
    amCharts5: import.meta.env.VITE_AMCHARTS_5_KEY,
    amCharts4: import.meta.env.VITE_AMCHARTS_4_KEY,
  },
  MARKER_PROJECT_ID: import.meta.env.VITE_MARKER_PROJECT_ID,
  LATEST_SHA: import.meta.env.VITE_LATEST_SHA,
  buildId: import.meta.env.VITE_BUILD_ID || import.meta.env.VITE_LATEST_SHA,
  releaseVersion: import.meta.env.VITE_RELEASE_VERSION,
  versionManifestUrl: import.meta.env.VITE_VERSION_MANIFEST_URL || '/version-admin.json',
  providerClientUrl: import.meta.env.VITE_PROVIDER_CLIENT_URL,
  environment: import.meta.env.VITE_ENV || 'dev',
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID
};

export default config;
